



















import { Component, Prop, Vue } from "vue-property-decorator";
import { Answer } from "../models/Card";

function dateFormat(date: Date): string {
  const hours = String(date.getHours()).padStart(2, "0");
  const mins = String(date.getMinutes()).padStart(2, "0");
  const secs = String(date.getSeconds()).padStart(2, "0");
  return `${hours}:${mins}:${secs}`;
}

@Component({
  name: "History",
  filters: {
    dateFormat: dateFormat,
  },
})
export default class History extends Vue {
  @Prop({ default: () => [] }) history!: Answer[];
}
